import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { NewStyleColor, BaseStyledComponentProps } from '../../utils/styles-constants';
import { spin, hexToRgba } from '../../utils/style';
import { Image } from './UserAvatar/styles';
import { AvatarSize } from '../../containers/ProfilePage/reducer';

interface ButtonSaveProps {
	disabled: boolean;
}

interface InputProps {
	isError?: boolean;
	readOnly?: boolean;
}

const Header = styled('div')`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-end;
	justify-content: space-between;
	margin-bottom: 30px;

	${Image} {
		width: ${AvatarSize.BIG}px;
		margin: 0 auto;
	}
`;

const UserInfoWrapper = styled('div')`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	min-width: 0;
`;

const Loader = styled('div')`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	font-size: 21px;
	background-color: ${hexToRgba(NewStyleColor.White, 80)};

	svg {
		height: 35px;
		width: 35px;
		animation: ${spin};
		margin-right: 20px;
	}
`;

const buttonCommonStyles = `
	box-sizing: border-box;
	min-width: 145px;
	height: 50px;
	padding: 0 10px;
	border: 0;
	border-radius: 9px;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 700;
	font-size: 18px;
	line-height: 50px;
	cursor: pointer;
	transition: background-color 0.2s;
	white-space: nowrap;
`;

const ButtonSave = styled('button')`
	${buttonCommonStyles}
	margin: 20px 0 10px 15px;
	background-color: ${hexToRgba(NewStyleColor.VibrantGreen, 10)};
	color: ${NewStyleColor.VibrantGreen};

	${(props: ButtonSaveProps) => props.disabled && `
		color: ${NewStyleColor.Grey400};
		cursor: default;
		opacity: 0.5;
	`}

	&:not(:disabled):hover {
		background-color: ${hexToRgba(NewStyleColor.VibrantGreen, 25)};
	}
`;

const ButtonLogout = styled('button')`
	${buttonCommonStyles}
	margin-top: 20px;
	margin-left: auto;
	background-color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.actionColor, 10)};
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};

	&:not(:disabled):hover {
		background-color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.actionColor, 25)};
	}
`;

const Input = styled('input')`
	box-sizing: border-box;
	display: block;
	width: 100%;
	padding: 20px 15px;
	border: 0;
	border-bottom: 1px solid ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 11.9)};
	border-radius: 0; /* fix for iOS */
	outline: 0;
	background-color: transparent;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 19px;
	color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 59.5)};
	-webkit-appearance: none;

	${(props: InputProps) => props.isError && `border-color: ${NewStyleColor.Red100};`}

	${(props: InputProps) => props.readOnly && `background-color: ${hexToRgba(NewStyleColor.Grey100, 50)};`}

	&:not(:read-only):focus {
		border-color: ${(props: InputProps) => props.isError
			? `${NewStyleColor.Red100}`
			: `${NewStyleColor.VibrantGreen}`
		};
	}

	::placeholder{
		color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 35.7)};
	};

	::-ms-clear {
		display: none;
	}

	:last-child {
		margin-bottom: -4px;
	}
`;

const InputLabel = styled('label')`
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${NewStyleColor.Black};
`;

const Error = styled(Translate)`
	font-size: 16px;
	line-height: 20px;
	color: ${NewStyleColor.Red100};
`;

const PopupBody = styled('div')`
	padding: 20px;

	${Input} {
		margin-bottom: 20px;
		padding: 10px 0;
	}
`;

const PopupLoader = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Message = styled(Translate)`
	display: inline-block;
	padding: 20px;
	border-radius: 9px;
	background-color: ${hexToRgba(NewStyleColor.Red100, 10)};
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${NewStyleColor.Red100};
`;

export {
	Header,
	UserInfoWrapper,
	Loader,
	ButtonSave,
	ButtonLogout,
	Input,
	InputLabel,
	Error,
	PopupBody,
	PopupLoader,
	Message,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/styles.ts